import * as React from 'react';
import { connect } from 'react-redux';

import { selectCatalogingOnSiteEnabled } from '../../catalog/selectors/CatalogSelectors';
import { NavLocationSelectors } from '../selectors/NavigationStateSelectors';
import { SessionServerSelectors, SessionSiteSelectors, SessionUserSelectors } from '../selectors/SessionInfoSelectors';
import { siteUrlsSelector } from '../selectors/SiteUrlsSelectors';
import { AppState } from '../state/AppState';
import { MapStateToProps } from '../utils/ConnectUtils';
import { NavPanel, NavPanelOwnProps, NavPanelStateProps } from './NavPanel';

const mapStateToProps: MapStateToProps<NavPanelStateProps> = (state: AppState) => ({
  siteUrls: siteUrlsSelector(state),
  currentNavLocation: NavLocationSelectors.selectNavLocation(state),
  inServerArea: NavLocationSelectors.inServerArea(state),
  isSessionSiteAdmin: SessionSiteSelectors.isSessionSiteAdmin(state),
  isSessionServerAdmin: SessionUserSelectors.isSessionServerAdmin(state),
  isSessionMultiSite: SessionUserSelectors.isSessionMultiSite(state),
  isSiteAdminSettingsEnabled: SessionServerSelectors.isSiteAdminSettingsEnabled(state),
  isAdminViewsEnabled: SessionServerSelectors.isAdminViewsEnabled(state),
  isCatalogingOnSiteEnabled: selectCatalogingOnSiteEnabled(state),
  isNamedSharingEnabled: SessionSiteSelectors.isNamedSharingEnabled(state),
  isVizRecommendationsEnabled: SessionSiteSelectors.isVizRecommendationsEnabled(state)
});

export const ConnectedNavPanel: React.ComponentClass<NavPanelOwnProps> =
  connect(mapStateToProps)(NavPanel);
